// Constants
import { EMPTY_OBJECT, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import OPERATORS from '@tekion/tekion-base/constants/filterOperators';
import { DEFAULT_FILTER_GROUP } from '../../constants/filterSection.filterGroups';
export var INITIAL_STATE = {
  editMode: undefined,
  fields: EMPTY_OBJECT,
  filterGroupName: undefined,
  isModified: false,
  isPopoverVisible: false,
  sections: EMPTY_ARRAY,
  values: EMPTY_OBJECT
};
export var BINARY_OPERATORS = [OPERATORS.BTW_INCLUSIVE, OPERATORS.BTW];